/* PASTOS CUSTOM: Keep variant labels as Color: Selected / Size: Selected */
(function(){
  let ticking=false;

  function selectedValue(box){
    const checked=box.querySelector('input[type="radio"]:checked,input:checked');
    if(checked) return checked.value;

    const select=box.querySelector('select');
    if(select) return select.options[select.selectedIndex]?.text || select.value;

    return '';
  }

  function updateLabels(){
    document.querySelectorAll('.product-form__input').forEach(box=>{
      const label=box.querySelector('.form__label');
      if(!label) return;

      const value=selectedValue(box);
      if(!value) return;

      let name=label.dataset.pastosName || label.textContent.split(':')[0].trim();
      label.dataset.pastosName=name;

      const html='<strong>'+name+':</strong> <span>'+value+'</span>';
      if(label.innerHTML!==html) label.innerHTML=html;
    });
  }

  function scheduleUpdate(){
    if(ticking) return;
    ticking=true;
    requestAnimationFrame(()=>{
      ticking=false;
      updateLabels();
      setTimeout(updateLabels,50);
      setTimeout(updateLabels,200);
      setTimeout(updateLabels,500);
    });
  }

  document.addEventListener('DOMContentLoaded',scheduleUpdate);
  document.addEventListener('change',scheduleUpdate,true);
  document.addEventListener('click',scheduleUpdate,true);

  new MutationObserver(scheduleUpdate).observe(document.body,{
    childList:true,
    subtree:true
  });
})();